/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.openCart = () => {
  document.getElementById("cartModal").classList.add("active");
  document.body.style.overflow = "hidden";
};

window.closeCart = () => {
  document.getElementById("cartModal").classList.remove("active");
  document.body.style.overflow = "auto";
};
window.refreshCartContents = async (response) => {
  const offcanvasCart = document.querySelector("#offcanvas-cart");
  const cartPage = document.querySelector("#cart");

  offcanvasCart?.classList.add("loading");
  cartPage?.classList.add("loading");

  const newResponse = await fetch(window.location.href);
  const text = await newResponse.text();
  const newDocument = new DOMParser().parseFromString(text, "text/html");

  offcanvasCart
    ?.querySelector(".offcanvas-body")
    .replaceWith(newDocument.querySelector("#offcanvas-cart .offcanvas-body"));
  offcanvasCart
    ?.querySelector(".offcanvas-footer")
    .replaceWith(
      newDocument.querySelector("#offcanvas-cart .offcanvas-footer")
    );
  cartPage?.replaceWith(newDocument.querySelector("#cart"));

  document.querySelectorAll(".cart-count-badge").forEach((badge) => {
    badge.textContent =
      newDocument.querySelector(".cart-count-badge").textContent;
    badge.removeAttribute("hidden");
  });

  offcanvasCart?.classList.remove("loading");
  cartPage?.classList.remove("loading");

  window.dispatchEvent(new Event("updated.ecomify.cart"));

  if (response.ok) {
    if (response.url.includes("add.js")) {
      offcanvasCart
        ?.querySelector("#offcanvas-cart-alert-add")
        .removeAttribute("hidden");

      const data = await response.json();

      if (data.items?.length > 1) {
        const elemAlertItemsAdded = offcanvasCart?.querySelector(
          "#offcanvas-cart-alert-add [data-alert-items-added]"
        );

        elemAlertItemsAdded.textContent =
          elemAlertItemsAdded.textContent.replace("[count]", data.items.length);
        elemAlertItemsAdded.removeAttribute("hidden");
      } else {
        offcanvasCart
          ?.querySelector("#offcanvas-cart-alert-add [data-alert-item-added]")
          .removeAttribute("hidden");
      }
    } else {
      offcanvasCart
        ?.querySelector("#offcanvas-cart-alert-updated")
        .removeAttribute("hidden");
    }
  } else {
    const data = await response.json();
    const alert = document.querySelector("#offcanvas-cart-alert-error");
    alert.querySelector(
      "span"
    ).textContent = `${data.message} - ${data.description}`;
    alert.removeAttribute("hidden");
  }

  if (offcanvasCart?.querySelector("#offcanvas-cart-empty")) {
    setTimeout(() => {
      bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide();
    }, 1000);
  }

  if (offcanvasCart?.querySelector("#cart-shipping-rates")) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(
      "shipping-rates-modal-country",
      "shipping-rates-modal-province",
      {
        hideElement: "shipping-rates-modal-province-wrapper",
      }
    );
  }
};

window.updateModalContents = async () => {
  try {
    const cartData = await window.getCartData();
    if (!cartData || !cartData?.token) return null;

    // empty cart manipulation
    const emptyCart = document.getElementById("emptyCart");
    if (emptyCart)
      emptyCart.style.display = cartData.item_count > 0 ? "none" : "block";
    // Milestone thresholds and rewards
    const thresholds = [49900, 69900, 99900];
    const deliveryCharge = cartData.total_price > thresholds[0] ? 0 : 5000;
    const rewards = ["Free Shipping", "Free Gift", "25% Off"];
    const icons = ["🚛", "🎁", "💰"];
    let currentStep = 0;
    let milestoneDiscount = 0;
    let mainDiscount = 0;

    const stepProgress = document.getElementById("stepProgress");
    const milestoneText = document.getElementById("milestoneText");

    const navCartItemsDoc = document.querySelectorAll(".cart-count-badge");
    const cartTitle = document.getElementById("cartTitle");
    if (cartTitle) {
      cartTitle.innerText = `YOUR CART (${cartData.item_count} item${
        cartData.item_count > 1 ? "s" : ""
      })`;
    }
    if (navCartItemsDoc) {
      if (cartData.item_count > 0) {
        navCartItemsDoc.forEach((el) => {
          el.textContent = cartData.item_count;
          el.removeAttribute("hidden");
          el.classList.remove("bg-white", "text-body");
          el.classList.add("bg-primary");
        });
      } else {
        navCartItemsDoc.forEach((el) => {
          el.textContent = "0";
          el.setAttribute("hidden", true);
        });
      }
    }

    for (let i = 0; i < thresholds.length; i++) {
      if (cartData.total_price >= thresholds[i]) {
        currentStep = i + 1;
      } else {
        break;
      }
    }

    const wrapper = document.getElementById("cartItemWrapper");
    if (!wrapper) return;

    wrapper.innerHTML = await generateCartItemHTML(cartData); // Custom JS function below

    // Update stepper UI
    for (let i = 1; i <= 3; i++) {
      const step = document.getElementById(`step${i}`);
      if (step) {
        step.classList.remove("active", "completed");

        if (i <= currentStep) {
          if (i === currentStep && currentStep < 3) {
            step.classList.add("completed");
            const iconEl = step.querySelector(".step-icon");
            if (iconEl) iconEl.innerHTML = icons[i - 1];
          } else if (
            i < currentStep ||
            (i === currentStep && currentStep === 3)
          ) {
            currentStep === 3 && i === 2
              ? null
              : step.classList.add("completed");
            currentStep === 3 && i === 2
              ? (step.querySelector(".step-icon").innerHTML = icons[i - 1])
              : (step.querySelector(".step-icon").innerHTML = "✅");
          }
        } else {
          step.querySelector(".step-icon").innerHTML = icons[i - 1];
        }
      }
    }

    const progressWidthList = [16.66, 50, 83.34];

    // Update progress bar
    if (stepProgress) {
      if (cartData.total_price >= thresholds[2]) {
        stepProgress.style.width = "100%";
      } else if (thresholds[currentStep]) {
        const width =
          (progressWidthList[currentStep] / thresholds[currentStep]) *
          cartData.total_price;
        stepProgress.style.width = `${width}%`;
      } else {
        stepProgress.style.width = "0%";
      }
    }

    // Update milestone text for next goal
    if (milestoneText) {
      if (currentStep < 3) {
        const nextThreshold = thresholds[currentStep];
        const remaining = nextThreshold - cartData.total_price;
        const nextReward = rewards[currentStep];
        const nextIcon = icons[currentStep];

        milestoneText.innerHTML = `<span>${nextIcon} Add Rs. ${(
          Math.max(0, remaining) / 100
        ).toFixed(2)} more for ${nextReward.toLowerCase()}</span>`;
      } else {
        milestoneText.innerHTML = `<span>🎉 All rewards unlocked!</span>`;
      }
    }

    for (let i = 0; i < cartData.items.length; i++) {
      const currentPrice = document.getElementById(
        `currPrice${cartData.items[i].id}`
      );
      const originalPrice = document.getElementById(
        `orgPrice${cartData.items[i].id}`
      );
      const compPrice = document.getElementById(
        `compPrice${cartData.items[i].id}`
      );
      const compPriceValElem = document.getElementById(
        `compPriceVal${cartData.items[i].id}`
      );
      const compPriceValue = compPriceValElem
        ? parseFloat(compPriceValElem.innerHTML)
        : 0;
      mainDiscount +=
        cartData.items[i].variant.compare_at_price * cartData.items[i].quantity;

      if (currentPrice) {
        currentPrice.innerHTML = `Rs. ${(
          cartData.items[i].final_line_price / 100
        ).toFixed(2)}`;
      }
      if (originalPrice) {
        originalPrice.innerHTML = `Rs. ${(
          cartData.items[i].original_line_price / 100
        ).toFixed(2)}`;
      }
      if (compPrice) {
        compPrice.innerHTML = `Rs. ${(
          (cartData.items[i].variant.compare_at_price *
            cartData.items[i].quantity) /
          100
        ).toFixed(2)}`;
      }
    }

    const discountRow = document.getElementById("discountRow");
    const breakdownDiscount = document.getElementById("breakdownDiscount");

    if (cartData.total_price >= thresholds[2]) {
      milestoneDiscount = Math.min(cartData.total_price * 0.25, 8000); // 25% off up to ₹80
      if (discountRow && breakdownDiscount) {
        discountRow.style.display = "flex";
        breakdownDiscount.textContent = `- Rs. ${(
          milestoneDiscount / 100
        ).toFixed(2)}`;
      }
    } else {
      const discountRow = document.getElementById("discountRow");
      if (discountRow) {
        discountRow.style.display = "none";
      }
    }

    const breakdownPrice = document.getElementById("breakdownPrice");
    const originalDiscount = document.getElementById("originalDiscount");
    const deliveryChargesDoc = document.getElementById("deliveryCharges");
    const breakdownTotal = document.getElementById("breakdownTotal");
    const savingsAmount = document.getElementById("savingsAmount");
    const totalItemCount = document.getElementById("totalItemCount");

    breakdownPrice.innerText = `Rs. ${(mainDiscount / 100).toFixed(2)}`;
    totalItemCount.innerText = `(${cartData.item_count} item${
      cartData.item_count !== 1 ? "s" : ""
    })`;

    originalDiscount.innerText = `-Rs. ${(
      (mainDiscount - cartData.total_price) /
      100
    ).toFixed(2)}`;
    deliveryChargesDoc.style.textDecoration = !!deliveryCharge
      ? "none"
      : "line-through";
    breakdownTotal.innerText = `Rs. ${(
      (cartData.total_price + deliveryCharge - milestoneDiscount) /
      100
    ).toFixed(2)}`;
    savingsAmount.innerText = `Rs. ${(
      (mainDiscount -
        cartData.total_price +
        (!deliveryCharge ? 5000 : 0) +
        milestoneDiscount) /
      100
    ).toFixed(2)}`;

    const cartFooter = document.querySelector(".cart-footer");
    const cartForm = cartFooter?.querySelector("form");
    const continueButton = cartFooter?.querySelector("a");
    const priceBreakupDoc = document.getElementById("priceBreakup");

    // 1. Dynamically hide/show parts of the footer
    if (cartData.item_count > 0) {
      if (cartForm) cartForm.style.display = "block";
      if (continueButton) continueButton.style.display = "none";
      if (continueButton) priceBreakupDoc.style.display = "block";
    } else {
      if (cartForm) cartForm.style.display = "none";
      if (continueButton) continueButton.style.display = "block";
      if (continueButton) priceBreakupDoc.style.display = "none";
    }
  } catch (error) {
    console.error("Something went wrong:", error);
    alert("Error: " + error.message);
  }
};

function generateCartItemHTML(cart) {
  if (cart.items.length === 0) {
    return `
      <div class="empty-cart">
        <div class="empty-cart-icon">🛒</div>
        <h3>Your cart is empty</h3>
        <p>Add some products to get started!</p>
      </div>
    `;
  }
  return cart.items
    .map(
      (item) => `
    <div class="cart-item" id="${item.key}" data-key="${item.key}">
      <div class="item-image">
        ${
          item.image
            ? `<img src="${item.image.replace(
                /(\.[^/.]+)$/,
                "_120x120$1"
              )}" alt="${item.title}">`
            : "📦"
        }
      </div>
      <div class="item-details">
        <div class="item-name">${item.product_title.slice(0, 50)}</div>
        ${
          item.variant_title !== "Default Title"
            ? `<div style="font-size: 12px; color: #666; margin-bottom: 5px;">${
                !!item.variant_title ? item.variant_title : ""
              }</div>`
            : ""
        }
        <div class="item-price">
          <span class="current-price" id="currPrice{{ item.id }}">
            Rs. ${(item.final_line_price / 100).toFixed(2)}
          </span>
          <span class="product-item-price-compare text-muted ms-1">
            <s class="product-item-price-compare-text" id="compPrice${item.id}">
              Rs. ${(
                (item.variant.compare_at_price * item.quantity) /
                100
              ).toFixed(2)}
            </s>
          </span>
        </div>
        <div class="quantity-wrapper quantity-controls">
          <button class="qty-btn" type="button" data-mode="minus" onclick="onClickQtyPlusMinus(this)">-</button>
          <input class="qty-input" name="updates[]" id="updates_${
            item.key
          }" type="number" value="${item.quantity}" data-line-item-key="${
        item.key
      }" aria-label="${"cart.quantity"}" data-min-qty="0" onchange="onChangeCartQty(this)">
          <button class="qty-btn" type="button" data-mode="plus" onclick="onClickQtyPlusMinus(this)">+</button>
        </div>
      </div>
      <button
          class="btn ms-2"
          type="button"
          data-remove-line-item
          data-line-item-key="${item.key}"
          onclick="onRemoveCartItem(this)"
          aria-label="{{ 'cart.remove' | t }}"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="opacity-60"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
        </button>
    </div>
  `
    )
    .join("");
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: input.dataset.lineItemKey,
      quantity: input.value,
    }),
  });
  await window.updateModalContents();
  window.refreshCartContents(response);
};

window.getCartData = async () => {
  try {
    const response = await fetch("/cart.js");
    const res = await response.json();

    // Enrich each item with variant data
    const enrichedItems = await Promise.all(
      res.items.map(async (item) => {
        const variant = await fetchVariantDetails(item.handle, item.variant_id);
        console.log("Variant details for", item.handle, variant);
        return {
          ...item,
          variant,
        };
      })
    );

    res.items = enrichedItems;
    return res;
  } catch (error) {
    console.error("Failed to fetch cart data:", error);
    alert(error.message);
  }
};

const fetchVariantDetails = async (productHandle, variantId) => {
  const res = await fetch(`/products/${productHandle}.js`);
  const product = await res.json();

  return product.variants.find((v) => v.id === variantId);
};

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: btn.dataset.lineItemKey,
      quantity: 0,
    }),
  });
  const cartData = await response.json();
  window.updateModalContents(cartData);
  const productItem = document.getElementById(btn.dataset.lineItemKey);
  if (productItem) productItem.remove();
  window.refreshCartContents(response);
};

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

  const note = btn.closest("#cart-note").querySelector('[name="note"]').value;

  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
  });

  btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`;

  setTimeout(() => {
    btn.innerHTML = btn.dataset.textBtnSave;
  }, 4000);
};

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
  btn.style.height = btn.clientHeight + "px";
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
};

// Cart Goal - Animate width
const initCartGoal = () => {
  const progressBar = document.querySelector("#cart-goal .progress-bar");
  if (progressBar) {
    setTimeout(() => {
      progressBar.style.width = progressBar.dataset.width;
    }, 250);
  }
};
initCartGoal();

window.addEventListener("updated.ecomify.cart", () => {
  initCartGoal();
});

// Cart Goal - Free product
const initCartGoalFreeProduct = async () => {
  const cartGoal = document.querySelector("#cart-goal");
  if (!cartGoal) return;

  const freeProductHandle = cartGoal.dataset.freeProductHandle;
  if (!freeProductHandle.length) return;

  const goalCompleted = cartGoal.dataset.goalCompleted === "2";
  let isFreeProductInCart = false;

  document.querySelectorAll("[data-cart-line-item]").forEach((elem) => {
    if (elem.dataset.productHandle === freeProductHandle) {
      isFreeProductInCart = true;
    }
  });

  const freeProductVariantId = Number(cartGoal.dataset.freeProductVariantId);

  if (goalCompleted) {
    if (!isFreeProductInCart) {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: freeProductVariantId,
              quantity: 1,
            },
          ],
        }),
      });
      window.refreshCartContents(response);
    }
  }

  console.log(freeProductHandle);
};
initCartGoal();

window.addEventListener("updated.ecomify.cart", () => {
  initCartGoalFreeProduct();
});

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
  const card = document.querySelector("#cart-summary");

  if (!card) return;

  if (window.matchMedia("max-width: 991px").matches) return;

  const navbarHeight =
    document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0;
  const announcementBarHeight =
    document.querySelector('[id*="__announcement-bar"].sticky-top')
      ?.clientHeight || 0;

  card.style.position = "sticky";
  card.style.top = `${navbarHeight + announcementBarHeight + 20}px`;
};
initStickySummaryCard();

window.addEventListener("updated.ecomify.cart", () => {
  initStickySummaryCard();
});

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;

  const wrapper = document.querySelector("#cart-shipping-rates-collapse");

  wrapper.querySelector("#shipping-rates-modal-alert-danger").innerHTML = "";
  wrapper
    .querySelector("#shipping-rates-modal-alert-danger")
    .setAttribute("hidden", "hidden");
  wrapper.querySelector("#shipping-rates-modal-alert-warning").innerHTML = "";
  wrapper
    .querySelector("#shipping-rates-modal-alert-warning")
    .setAttribute("hidden", "hidden");
  wrapper.querySelector("#shipping-rates-modal-alert-success").innerHTML = "";
  wrapper
    .querySelector("#shipping-rates-modal-alert-success")
    .setAttribute("hidden", "hidden");

  const country = wrapper.querySelector("#shipping-rates-modal-country").value;
  const province = wrapper.querySelector(
    "#shipping-rates-modal-province"
  ).value;
  const zip = wrapper.querySelector("#shipping-rates-modal-zip").value;

  const prepareResponse = await fetch(
    `/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
    {
      method: "POST",
    }
  );
  console.log(prepareResponse);

  if (prepareResponse.ok) {
    const asyncRespose = await fetch(
      `/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
    );
    console.log(asyncRespose);

    const data = await asyncRespose.json();
    console.log(data);

    let html = "";

    if (data.shipping_rates.length) {
      data.shipping_rates.forEach((elem) => {
        html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `;
      });

      wrapper.querySelector("#shipping-rates-modal-alert-success").innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `;
      wrapper
        .querySelector("#shipping-rates-modal-alert-success")
        .removeAttribute("hidden");
    } else {
      wrapper.querySelector("#shipping-rates-modal-alert-warning").innerHTML = `
                <p class="mb-0">
                    ${wrapper.dataset.textNoResults}
                </p>
            `;
      wrapper
        .querySelector("#shipping-rates-modal-alert-warning")
        .removeAttribute("hidden");
    }
  } else {
    const data = await prepareResponse.json();
    console.log(data);

    let html = "";

    for (const [key, value] of Object.entries(data)) {
      html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `;
    }

    wrapper.querySelector("#shipping-rates-modal-alert-danger").innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `;
    wrapper
      .querySelector("#shipping-rates-modal-alert-danger")
      .removeAttribute("hidden");
  }

  btn.innerHTML = btn.dataset.text;
};

// Offcanvas cart - fix scrolling for callapses
const fixScrollingOffcanvasCollapses = () => {
  document
    .querySelectorAll('#offcanvas-cart [data-bs-toggle="collapse"]')
    .forEach((elem) => {
      elem.addEventListener("click", () => {
        setTimeout(() => {
          const offcanvasBody = document.querySelector(
            "#offcanvas-cart .offcanvas-body"
          );
          offcanvasBody.scroll({
            top: offcanvasBody.scrollHeight,
            behavior: "smooth",
          });
        }, 250);
      });
    });
};
fixScrollingOffcanvasCollapses();

window.addEventListener("updated.ecomify.cart", () => {
  fixScrollingOffcanvasCollapses();
});

// Upgrade to subscription
window.onChangeCartUpgradeToSub = async (select) => {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  });

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.dataset.variantId),
          selling_plan: Number(select.value),
        },
      ],
    }),
  });

  window.refreshCartContents(response);
};

// Gift Wrap
window.onChangeCartGiftWrap = async (input) => {
  let response;

  if (input.checked) {
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          },
        ],
      }),
    });
  } else {
    response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    });
  }
  window.refreshCartContents(response);
};

// Cart Min Order
const initCartMinOrder = () => {
  const wrapper = document.querySelector("#cart-min-order");
  if (!wrapper) return;

  if (wrapper.dataset.goalReached === "false") {
    wrapper.closest("form").querySelector(".btn-checkout").disabled = true;
  }
};
initCartMinOrder();
window.addEventListener("updated.ecomify.cart", () => {
  initCartMinOrder();
});

// Shipping protection
const initCartShippingProtection = async () => {
  if (!document.querySelector('[data-shipping-protection-enabled="true"]'))
    return;
  if (!document.querySelector('[data-shipping-protection-auto-init="true"]'))
    return;

  if (!window.localStorage.getItem("ecomify-shipping-protection-init")) {
    const variantId = Number(
      document.querySelector("[data-shipping-protection-variant-id]").dataset
        .shippingProtectionVariantId
    );

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: variantId,
          },
        ],
      }),
    });

    window.refreshCartContents(response);
    window.localStorage.setItem("ecomify-shipping-protection-init", true);
  }
};
window.addEventListener("updated.ecomify.cart", () => {
  initCartShippingProtection();
});

window.onChangeCartShippingProtection = async (input) => {
  let response;

  if (input.checked) {
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: Number(input.value),
          },
        ],
      }),
    });
  } else {
    response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: input.dataset.lineItemKey,
        quantity: 0,
      }),
    });
  }
  window.refreshCartContents(response);
};

// Variant switcher
window.onChangeCartLineItemVariant = async (select) => {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: select.dataset.lineItemKey,
      quantity: 0,
    }),
  });

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(select.dataset.quantity),
          id: Number(select.value),
          selling_plan: select.dataset.sellingPlanId.length
            ? Number(select.dataset.sellingPlanId)
            : null,
        },
      ],
    }),
  });

  window.refreshCartContents(response);
};

// Terms checkbox
const initTermsCheckbox = () => {
  const checkbox = document.querySelector("#cart-terms-checkbox");

  if (!checkbox) return;

  const checkoutBtn = checkbox.closest("form").querySelector(".btn-checkout");
  checkoutBtn.disabled = true;

  checkbox.addEventListener("change", () => {
    if (checkbox.checked) {
      checkoutBtn.disabled = false;
    } else {
      checkoutBtn.disabled = true;
    }
  });
};
initTermsCheckbox();

window.addEventListener("updated.ecomify.cart", () => {
  initTermsCheckbox();
});

// Cart Discount
window.onCartDiscountClick = async (btn) => {
  const wrapper = document.querySelector("#cart-discount");

  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
  await fetch(`/discount/${wrapper.querySelector(".form-control").value}`);
  window.location.href = "/checkout";
};
